export var MainColors;
(function (MainColors) {
    MainColors[MainColors["systemSync"] = 0] = "systemSync";
    MainColors[MainColors["dark"] = 1] = "dark";
    MainColors[MainColors["darkBlue"] = 2] = "darkBlue";
    MainColors[MainColors["light"] = 3] = "light";
    MainColors[MainColors["lightBlue"] = 4] = "lightBlue";
})(MainColors || (MainColors = {}));
export var AccentColors;
(function (AccentColors) {
    AccentColors[AccentColors["community"] = 0] = "community";
    AccentColors[AccentColors["random"] = 1] = "random";
    AccentColors[AccentColors["rainbow"] = 2] = "rainbow";
    AccentColors[AccentColors["orange"] = 3] = "orange";
    AccentColors[AccentColors["violet"] = 4] = "violet";
})(AccentColors || (AccentColors = {}));
//# sourceMappingURL=themes.js.map